module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-orange-6728cbc46f8b49b7e31b74762a3ee51f.svg";